import { AnyAction } from "redux";
import actions from "../../util/actions";
import { MinistriesReducerState } from "../../interfaces";

const initialState: MinistriesReducerState = {
  initial: false,
  loading: true,
  error: null,
  response: null,
  data: []
};

const reducer = (state = initialState, action: AnyAction): MinistriesReducerState => {
  switch (action.type) {
    case actions.MINISTRIES_HTTP_LOADING:
      return { ...state, response: null, loading: true, error: null };
    case actions.MINISTRIES_HTTP_ERROR:
      if (action.payload.clear) {
        return { ...state, response: null, loading: false, error: null };
      }
      return { ...state, response: null, loading: false, error: { ...action.payload } };
    case actions.MINISTRIES_HTTP_COMPLETE:
      return { ...state, initial: true, response: action.payload.response, loading: false, error: null };
    case actions.SET_MINISTRIES_DETAILS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
